import {
  convertToCamelCaseFromUnderScore,
  exportToExcel,
} from "../../../../common-utilities/utils";
import { getPOGrandTotal } from "../../purchase-order/helper";
import { getGRNGrandTotal } from "../grn-details/helper";

export const downloadReports = (data, status) => {
  if (!data?.length) {
    return;
  }
  const statusLabel =
    status === "approval_in_progress" ? "Pending With" : "GRN Status";
  const results =
    data?.map?.((item) => {
      const purchaseOrderId = item?.purchaseOrderId;
      let statusValue = convertToCamelCaseFromUnderScore(item.status);
      if (status === "approval_in_progress") {
        const { approvalId = {} } = item;
        statusValue = `${approvalId && approvalId.pendingWith} `;
      }

      const site = item?.site;

      let convertedItem = {
        "GRN NO": item?.grnNo || null,
        "PO Number": purchaseOrderId?.poNumber || null,
        "Financial Year": purchaseOrderId?.financialYear || null,
        "Site Code": site?.code || null,
        "Site Name": site?.name || null,
        Remarks: item?.remarks || "",
        "Vendor Code": purchaseOrderId?.vendorCode || null,
        "Vendor Name": purchaseOrderId?.vendorName || null,
        [statusLabel]: statusValue,
      };
      if (status !== "approval_in_progress") {
        convertedItem = {
          ...convertedItem,
          "Pending With": item?.approvalId?.pendingWith || null,
        };
      }

      convertedItem = {
        ...convertedItem,
        "Total PO Value": getPOGrandTotal(purchaseOrderId),
        "Total GRN Value": getGRNGrandTotal(item),
      };
      if (status === "approved") {
        convertedItem["Payment Status"] = convertToCamelCaseFromUnderScore(
          item.paymentStatus || ""
        );
      }
      convertedItem["Created By"] = item?.creatorName;
      return convertedItem;
    }) || [];

  exportToExcel(results, "grn_reports");
};
